export default function IconLink({ className }) {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21 12H3m0 0 8.5-8.5M3 12l8.5 8.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
